import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import TratamentoDeDados from './TratamentoDeDados';
import EnviarInformacoes from './EnviarInformacoes';
import AlterarDefinicoesServidor from './AlterarDefinicoesServidor';
import Vies from './Vies';

const FerramentasAdmin = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <DashboardLayout>
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Ferramentas Administrativas</Typography>
                
                <Tabs value={selectedTab} onChange={handleChange} sx={{ marginBottom: 3 }}>
                    <Tab label="Tratamento de Dados" />
                    <Tab label="Enviar Informações" />
                    <Tab label="Dachser Encomendas" />
                    <Tab label="VIES" />
                </Tabs>

                {/* Conteúdo de cada aba */}
                <Box sx={{ p: 2 }}>
                    {selectedTab === 0 && <TratamentoDeDados />}
                    {selectedTab === 1 && <EnviarInformacoes />}
                    {selectedTab === 2 && <AlterarDefinicoesServidor />}
                    {selectedTab === 3 && <Vies />}
                </Box>
            </Box>
        </DashboardLayout>
    );
};

export default FerramentasAdmin;
